var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice-wrap"},[_c('el-image',{staticStyle:{"width":"800px","height":"500px"},attrs:{"src":_vm.url}}),_c('div',{staticStyle:{"text-align":"center"}},[_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.$emit('close-dg')}}},[_vm._v(_vm._s(_vm.msg('关闭')))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }